/*
  Private Route component for protecting routes that require authentication
*/

import React from 'react'
import { Navigate } from 'react-router-dom'
import { isLoggedIn } from '../../services/auth'

function PrivateRoute ({ children }) {
  // Throw the user back to the login page if they aren't logged in.
  if (!isLoggedIn()) {
    return <Navigate to='/login' replace />
  }

  // Load the component and props passed to this component.
  return children
}

export default PrivateRoute
